import api from './api'
export type Row = { id: string; [key: string]: any }
export type Site = Row & {name:string;ownerOrgId:string;capabilities:Record<string,boolean>;operations:Record<string,Record<string,number>|null>}
export type ClientContext = {actions:Record<string,boolean>;projects:Row[];jobs:Row[];workers:Row[];organizationId:string;timezone:string}
export const operationsPath='/api/supervisor'
export async function operationsRequest(path:string,method='GET',data?:unknown,headers?:Record<string,string>,signal?:AbortSignal) {
  const response=await api.request({url:path,method,data,headers,signal})
  if(!response.data || response.data.success===false) throw new Error('operations_response_invalid')
  return response.data
}
export async function operationsPages(path:string,field:string,signal?:AbortSignal):Promise<Row[]> {
  const rows:Row[]=[]
  for(let offset=0;offset<=100000;offset+=100) {
    const data=await operationsRequest(`${path}${path.includes('?')?'&':'?'}offset=${offset}`,'GET',undefined,undefined,signal)
    const page=data[field] as Row[];if(!Array.isArray(page)) throw new Error('operations_response_invalid')
    rows.push(...page);if(page.length<100) return rows
  }
  throw new Error('operations_collection_limit')
}
export function operationsError(error:any):string {
  const status=error?.response?.status
  if(status===403) return 'Access or capability is unavailable. Refresh your access and choose an authorized location.'
  if(status===409) return 'This record changed or is locked. Refresh, review the current version, and try again.'
  if(status===401) return 'Your session expired. Sign in again.'
  if(status===404) return 'This record is no longer available in your location.'
  if(status===400) return 'Check the required fields, dates, and selected people, then try again.'
  return 'The request could not be confirmed. Refresh before retrying a creation or publication.'
}
export const operationsDate=(value?:string|null,zone='UTC',locale?:string)=> {
  if(!value) return '—'
  try {return new Intl.DateTimeFormat(locale,{timeZone:zone,dateStyle:'medium',timeStyle:'short'}).format(new Date(value))}catch{return '—'}
}
/** Keys survive ambiguous network failures; they are discarded only with the reviewed decision. */
export class DecisionAttempt {
  private attempts=new Map<string,string>()
  key(id:string,revision:string,action:string,reason:string) {const fingerprint=JSON.stringify([id,revision,action,reason]);let key=this.attempts.get(fingerprint);if(!key){key=crypto.randomUUID();this.attempts.set(fingerprint,key)}return key}
  clear(){this.attempts.clear()}
}
/** Site-calendar presentation only; the server owns attendance/payroll arithmetic. */
export function siteDayWindow(zone:string,now=new Date()) {
 const parts=(date:Date)=>Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date).map(part=>[part.type,part.value]))
 const today=parts(now),day=Date.UTC(+today.year,+today.month-1,+today.day)
 const midnight=(stamp:number)=>{let candidate=stamp;for(let i=0;i<3;i++){const local=parts(new Date(candidate));const projected=Date.UTC(+local.year,+local.month-1,+local.day,+local.hour,+local.minute,+local.second);candidate+=stamp-projected}return new Date(candidate).toISOString()}
 return {from:midnight(day),to:midnight(day+86400000),upcomingTo:midnight(day+7*86400000)}
}
